import { useDataSubmit } from 'Simple/Data.js'
export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'lead',
    viewPath: props.viewPath,
  })
  return function onClick() {
    submit({ type: 'undismiss' })
  }
}
